import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {TableStyle} from '../../models/enums/tableStyle';
import {animate, style, transition, trigger, state} from '@angular/animations';
import {Sort} from '@angular/material/sort';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({height: 0, padding: 0})),
      state('expanded', style({height: '*'})),
      transition('expanded <=> collapsed', animate('0.3s cubic-bezier(0.77, 0, 0.175, 1)'))
    ]),
  ]
})
export class TableComponent<T> implements OnInit {
 // @Input() records: T[];
  @Output() getData: EventEmitter<any> = new EventEmitter<any>();
  @Output() updatePageSize: EventEmitter<any> = new EventEmitter<any>();
  @Output() sortData: EventEmitter<Sort> = new EventEmitter<Sort>();

  @Input() headerArray;
  @Input() headerDictionary;
  @Input() style;
  @Input() tableTitle: string;
  @Input() state;
  @Input() sortedRecords;
  @Input() path;
  @Input() pageSize;
  @Input() pageNumber;
  @Input() totalPages;

  showLoader = false;
  tableStyle = TableStyle;
  isAlreadyFetched: boolean;
  isWatchlist = false;

  constructor() {
  }


  ngOnInit(): void {
    if (this.tableTitle.toLocaleLowerCase() === 'watchlist') {
      this.isWatchlist = true;
    }
    this.isAlreadyFetched = false;
  }

  toggle() {
    this.state = this.state === 'collapsed' ? 'expanded' : 'collapsed';
    if (!this.isAlreadyFetched) {
      this.showLoader = true;
      this.getData.emit();
    }
    this.showLoader = false;
    this.isAlreadyFetched = true;
  }

  sendSortData(sort: Sort) {
    this.sortData.emit(sort);
  }

  nextPage() {
    ++this.pageNumber;
    this.getData.emit(this.pageNumber);
  }

  previousPage() {
    --this.pageNumber;
    this.getData.emit(this.pageNumber);
  }

  firstPage() {
    this.pageNumber = 1;
    this.getData.emit(this.pageNumber);
  }

  lastPage() {
    this.pageNumber = this.totalPages;
    this.getData.emit(this.pageNumber);
  }

  updateSize(event: any) {
    this.updatePageSize.emit(event);
  }
}
